@if (hasSocialLinks()) {
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
    @if (socialLinks()?.website) {
      <a
        [href]="socialLinks()!.website"
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center gap-3 p-4 bg-white dark:bg-neutral-2 hover:bg-neutral-1 dark:hover:bg-neutral-3 border border-neutral-3 dark:border-neutral-4 hover:border-neutral-4 dark:hover:border-neutral-5 rounded-2xl transition-all group shadow-xs cursor-pointer"
      >
        <div
          class="w-9 h-9 rounded-lg bg-primary-2 text-primary-11 flex items-center justify-center shrink-0"
        >
          <mat-icon class="!w-4.5 !h-4.5 !text-lg">language</mat-icon>
        </div>
        <div class="flex flex-col min-w-0 flex-1">
          <span class="text-[11px] font-semibold text-neutral-9 uppercase tracking-wider"
            >Site web officiel</span
          >
          <span
            class="text-xs font-bold text-neutral-12 truncate group-hover:text-primary-11 transition-colors"
          >
            {{ socialLinks()!.website }}
          </span>
        </div>
        <mat-icon class="text-neutral-7 group-hover:text-neutral-11 !w-4 !h-4 !text-base shrink-0"
          >open_in_new</mat-icon
        >
      </a>
    }
    @if (socialLinks()?.googleReviewUrl) {
      <a
        [href]="socialLinks()!.googleReviewUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center gap-3 p-4 bg-white dark:bg-neutral-2 hover:bg-neutral-1 dark:hover:bg-neutral-3 border border-neutral-3 dark:border-neutral-4 hover:border-neutral-4 dark:hover:border-neutral-5 rounded-2xl transition-all group shadow-xs cursor-pointer"
      >
        <div class="w-9 h-9 rounded-lg bg-amber-2 text-amber-11 flex items-center justify-center shrink-0">
          <mat-icon class="!w-4.5 !h-4.5 !text-lg">star</mat-icon>
        </div>
        <div class="flex flex-col min-w-0 flex-1">
          <span class="text-[11px] font-semibold text-neutral-9 uppercase tracking-wider">Avis Google</span>
          <span
            class="text-xs font-bold text-neutral-12 truncate group-hover:text-primary-11 transition-colors"
          >
            Consulter les avis clients
          </span>
        </div>
        <mat-icon class="text-neutral-7 group-hover:text-neutral-11 !w-4 !h-4 !text-base shrink-0"
          >open_in_new</mat-icon
        >
      </a>
    }
    @if (socialLinks()?.opinionSystemUrl) {
      <a
        [href]="socialLinks()!.opinionSystemUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center gap-3 p-4 bg-white dark:bg-neutral-2 hover:bg-neutral-1 dark:hover:bg-neutral-3 border border-neutral-3 dark:border-neutral-4 hover:border-neutral-4 dark:hover:border-neutral-5 rounded-2xl transition-all group shadow-xs cursor-pointer"
      >
        <div class="w-9 h-9 rounded-lg bg-blue-2 text-blue-11 flex items-center justify-center shrink-0">
          <mat-icon class="!w-4.5 !h-4.5 !text-lg">verified</mat-icon>
        </div>
        <div class="flex flex-col min-w-0 flex-1">
          <span class="text-[11px] font-semibold text-neutral-9 uppercase tracking-wider">Immodvisor</span>
          <span
            class="text-xs font-bold text-neutral-12 truncate group-hover:text-primary-11 transition-colors"
          >
            Attestation d'avis certifiés
          </span>
        </div>
        <mat-icon class="text-neutral-7 group-hover:text-neutral-11 !w-4 !h-4 !text-base shrink-0"
          >open_in_new</mat-icon
        >
      </a>
    }
    @if (socialLinks()?.linkedin) {
      <a
        [href]="socialLinks()!.linkedin"
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center gap-3 p-4 bg-white dark:bg-neutral-2 hover:bg-neutral-1 dark:hover:bg-neutral-3 border border-neutral-3 dark:border-neutral-4 hover:border-neutral-4 dark:hover:border-neutral-5 rounded-2xl transition-all group shadow-xs cursor-pointer"
      >
        <div class="w-9 h-9 rounded-lg bg-sky-2 text-sky-11 flex items-center justify-center shrink-0">
          <mat-icon class="!w-4.5 !h-4.5 !text-lg">work</mat-icon>
        </div>
        <div class="flex flex-col min-w-0 flex-1">
          <span class="text-[11px] font-semibold text-neutral-9 uppercase tracking-wider"
            >Profil LinkedIn</span
          >
          <span
            class="text-xs font-bold text-neutral-12 truncate group-hover:text-primary-11 transition-colors"
          >
            Voir le réseau professionnel
          </span>
        </div>
        <mat-icon class="text-neutral-7 group-hover:text-neutral-11 !w-4 !h-4 !text-base shrink-0"
          >open_in_new</mat-icon
        >
      </a>
    }
  </div>
} @else {
  <div
    class="p-6 text-center border-2 border-dashed border-neutral-3 dark:border-neutral-4 rounded-2xl bg-white dark:bg-neutral-2 shadow-xs max-w-full"
  >
    <p class="text-xs text-neutral-9 italic whitespace-normal break-words max-w-md mx-auto">
      Aucun réseau social ou lien d'avis en ligne renseigné pour le moment.
    </p>
  </div>
}
